<template>
    <section class="background-section">
      <img src="../assets/pass/Texto_2.png" alt="Imagen superior" class="top-image" />
      <img src="../assets/pass/recurso209.png" alt="Imagen central" class="center-image" />
      <img src="../assets/pass/texto 2.png" alt="Imagen inferior" class="bottom-image" />
    </section>
  </template>
  
  <script>
  export default {
    name: "ResponsiveBackgroundSection",
  };
  </script>
  
  <style scoped>
  .background-section {
    position: relative;
    width: 100%;
    height: 100vh;
    background: url('../assets/pass/fondo_1.png') no-repeat center center/cover;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: hidden;
  }
  
  .top-image {
    max-width: 25%;
    height: auto;
    position: absolute;
    top: 5%;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .center-image {
    max-width: 50%;
    height: auto;
  }
  
  .bottom-image {
    max-width: 35%;
    height: auto;
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
  }
  
  @media (max-width: 1024px) { /* Ajuste especial para tablets */
    .center-image {
      max-width: 56%;
    }
  }
  
  @media (max-width: 768px) {
    .center-image {
      max-width: 50%;
    }
  }
  </style>
  